import React from 'react';

const FormField = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  error, 
  required = false,
  fullWidth = false,
  disabled = false 
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`form-field ${fullWidth ? 'full-width' : ''}`}>
      <label className="field-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      
      <input
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`field-input ${error ? 'error' : ''}`}
        disabled={disabled}
        required={required}
      />
      
      {error && (
        <div className="field-error">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}
    </div>
  );
};

export default FormField;